import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'white';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-caces-navy text-white hover:bg-caces-blue focus-visible:ring-caces-navy',
    secondary: 'bg-caces-accent text-white hover:bg-caces-blue focus-visible:ring-caces-accent',
    outline: 'border-2 border-caces-navy text-caces-navy hover:bg-caces-sky focus-visible:ring-caces-navy',
    ghost: 'text-caces-navy hover:bg-caces-sky hover:text-caces-blue',
    white: 'bg-white text-caces-navy hover:bg-gray-100 focus-visible:ring-white'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button className={`
        ${baseStyles}
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} disabled={disabled || isLoading} {...props} data-id="element-103">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-104" />}
      {children}
    </button>;
}